import { observer } from "mobx-react";
import React, { useState } from "react";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "@/components/Elements";
import DashboardContent from "@/components/shared/DashboardContent";
import DashboardContentWrapper from "@/components/shared/DashboardContentWrapper";
import DashboardHeader from "@/components/shared/DashboardHeader";
import { useMainStore } from "@/contexts/Store";
import { ROUTES } from "@/features/risk-assessment";
import { AssessmentUpsert } from "@/features/risk-assessment/types/assessment";
import { usePreventUnsavedChanges } from "@/hooks/usePreventUnsavedChanges";

import { AssessmentAPI } from "../../../api/legacy/risk-assessment/AssessmentApi";
import AssessmentTemplate from "../components/Assessment/AssessmentTemplate/AssessmentTemplate";

function CreateAssessmentTemplatePage() {
  const mainStore = useMainStore();
  const { workspaceID } = mainStore.context;

  const history = useHistory();
  const [isSaving, setIsSaving] = useState(false);
  const [assessmentTemplate, setAssessmentTemplate] =
    useState<Partial<AssessmentUpsert> | null>({});

  const unblock = usePreventUnsavedChanges(
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    [Object.values(assessmentTemplate).some(Boolean)],
    [assessmentTemplate],
  );

  const onSave = () => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    if (!assessmentTemplate.name) {
      return mainStore.toast.setErrorText(
        "Assessment Template name is required",
      );
    }

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    if (!assessmentTemplate.risk_methodology_id) {
      return mainStore.toast.setErrorText("Risk Methodology is required");
    }

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    if (!assessmentTemplate.questionnaire_ids?.length) {
      return mainStore.toast.setErrorText(
        "At least one Questionnaire Template must be selected",
      );
    }

    setIsSaving(true);

    if (!assessmentTemplate || !mainStore.context.activeWorkspace) {
      return mainStore.toast.setErrorText("Something went wrong");
    }
    AssessmentAPI.create(mainStore.context.activeWorkspace.id, {
      assessment: {
        is_template: true,
        name: assessmentTemplate.name,
        questionnaire_ids: assessmentTemplate.questionnaire_ids,
      },
    })
      .then(() => {
        mainStore.toast.setText("Assessment Template saved!");
        unblock();
        history.push(
          generatePath(ROUTES.TEMPLATE_PATH, {
            workspace_id: Number(workspaceID),
          }),
        );
      })
      .catch((error) => {
        mainStore.toast.setErrorFromResponse(
          error,
          "There was an issue saving. Please try again",
        );
      })
      .finally(() => setIsSaving(false));
  };

  return (
    <DashboardContent>
      <DashboardHeader
        title="Add New Assessment Template"
        onBackClick={() =>
          history.push(
            generatePath(ROUTES.TEMPLATE_PATH, {
              workspace_id: Number(workspaceID),
            }),
          )
        }
        RightActionBar={
          <Button label="Save Template" onClick={onSave} disabled={isSaving} />
        }
      />
      <DashboardContentWrapper>
        {/* temporary scroll solution wrapping in .table-wrap */}
        <div className="table-wrap">
          <AssessmentTemplate
            assessmentTemplate={assessmentTemplate}
            onChange={setAssessmentTemplate}
          />
        </div>
      </DashboardContentWrapper>
    </DashboardContent>
  );
}

export default observer(CreateAssessmentTemplatePage);
